import React, { useEffect, useState } from "react";
import "./Pumping.css";
import Accordion from "react-bootstrap/Accordion";
import { formula_accordian_img, Puping_accordian } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { pumpFeedingListApi } from "services/pumpFeeding";
import moment from "moment";
import { dateFormatWithTime } from "utils/dateFormat";

const Pumping = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedingList, setFeedingList] = useState([]);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState({});


  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await pumpFeedingListApi({ childId: _child, limit: 5000 });
      if (status === 200) {
        setFeedingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loader}
      <div className="pumping_parent">
        <div className="pumping_wraper">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="formula_lft_side">
                <div className="formula_accordian">
                  <Accordion className="w-75">
                    <p className="formula_logo">Pumping Logs</p>

                    {
                      feedingList.map((feeding, i) => {
                        return <Accordion.Item eventKey={i} key={i}>
                          <Accordion.Header>
                            <div className="formula_header">
                              <h6>{moment(feeding._id, "YYYY-MM-DD").format("LL")}</h6>
                            </div>
                          </Accordion.Header>

                          {
                            feeding?.documents?.map((ele, j) => {
                              return <Accordion.Body onClick={() => setSelected(ele)} key={j}>
                                <div className="formula_timimg_inside">
                                  <div className="formula_timing_wraper">
                                    <div className="formula_lft_img">
                                      <img src={Puping_accordian} />
                                    </div>

                                    <div className="formula_rgt_content">
                                      <div className="formula_rgt_top">
                                        <div className="formula_timimg">
                                          <span>{dateFormatWithTime(ele?.createdAt)}</span>
                                          <div className="formula_liter">
                                            <b>L: {`${ele?.leftSide?.value} ${ele?.leftSide?.unit}`}</b>
                                            <b className="bold_right">R: {`${ele?.rightSide?.value} ${ele?.rightSide?.unit}`}</b>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Accordion.Body>
                            })
                          }
                        </Accordion.Item>
                      })
                    }
                  </Accordion>
                </div>
              </div>
            </div>

            {
              selected?._id
                ?
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="formula_right_side ">
                    <div className="doctor_visit_rgt">
                      <div className="doctor_visit_card">
                        <b>Pump Feeding</b>
                        <div className="date-time">
                          L: {`${selected?.leftSide?.value} ${selected?.leftSide?.unit} `}
                          R:  {`${selected?.rightSide?.value} ${selected?.rightSide?.unit}`}
                          <br />
                        </div>

                        <b>Date & Time</b>
                        <div className="date-time">
                          {dateFormatWithTime(selected?.createdAt)}
                          <br />
                        </div>

                        <b>Note</b>
                        <div className="motorskilltracking-note feeding_note">
                          <p>
                            {selected?.note}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                :
                null
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Pumping;
